export default __webpack_public_path__ + "static/media/pagination_left_arrow.4066a767.svg";